import PropTypes from 'prop-types';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import {injectIntl, intlShape} from 'react-intl';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject,
    LoadingStates,
    getIsLoadingUpload,
    getIsShowingWithoutId,
    onLoadedProject,
    requestProjectUpload
} from '../reducers/project-state';
import {
    activateTab,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary, closeLoadingProject, openLoadingProject
} from '../reducers/modals';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import SBFileUploaderHOC from '../lib/sb-file-uploader-hoc.jsx';
import messages from '../lib/sb-file-uploader-hoc.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';
import {setIsScratchDesktop} from '../lib/isScratchDesktop.js';

import sharedMessages from '../lib/shared-messages';
import log from '../lib/log';
import {closeFileMenu} from '../reducers/menus';
import {setProjectTitle} from '../reducers/project-title';
import bindAll from 'lodash.bindall';

class GUI extends React.Component {

    constructor (props) {
        super(props);
        bindAll(this, [
            'getProjectTitleFromFilename',
            'onload',
            'removeFileObjects'
        ]);
    }

    componentDidMount () {
        setIsScratchDesktop(this.props.isScratchDesktop);
        this.props.onStorageInit(storage);
        this.props.onVmInit(this.props.vm);


        const {
            once,
            setOnce,
            index
        } = this.props;
        const thisFileInput = this.props.scratchFile;

        if (once && thisFileInput) { // Don't attempt to load if no file was selected
            this.fileToUpload = thisFileInput;
            this.fileReader = new FileReader();
            this.fileReader.onload = this.onload;

            // If user owns the project, or user has changed the project,
            // we must confirm with the user that they really intend to
            // replace it. (If they don't own the project and haven't
            // changed it, no need to confirm.)
            let uploadAllowed = true;
            // if (userOwnsProject || (projectChanged && isShowingWithoutId)) {
            //     uploadAllowed = window.confirm( // eslint-disable-line no-alert
            //         intl.formatMessage(sharedMessages.replaceProjectWarning)
            //     );
            // }
            if (once) {
                if (once.current[index.current]) uploadAllowed = false;
            }
            if (uploadAllowed) {
                // cues step 4
                this.handleFinishedLoadingUpload(setOnce, index);
            } else {
                // skips ahead to step 7
                this.removeFileObjects();
            }
            // this.props.closeFileMenu();
        }
        console.log('mount roi needed');

    }
    componentDidUpdate (prevProps) {
        const {isClose} = this.props;
        if (isClose && (prevProps.isClose === false || null)) {
            this.props.saveProjectSb3().then(content => {
                if (this.props.onSaveFinished) {
                    this.props.onSaveFinished();
                }
                this.props.closeScratch(content);
            });
        }

        const {
            once,
            setOnce,
            index,
            baiMau
        } = this.props;
        if (!isClose && prevProps.isClose === true && !this.props.scratchFile && this.props.baiMau) {
            this.fileToUpload = baiMau;
            this.fileReader = new FileReader();
            this.fileReader.onload = this.onload;

            // cues step 4
            this.handleFinishedLoadingUpload(setOnce, index);
        }
        if ((this.props.scratchFile !== prevProps.scratchFile)) {
            let uploadAllowed = true;
            const thisFileInput = this.props.scratchFile;
            if (thisFileInput) {
                if (once) {
                    if (once.current[index.current]) uploadAllowed = false;
                }
                

                this.fileToUpload = thisFileInput;
                this.fileReader = new FileReader();
                this.fileReader.onload = this.onload;

                if (uploadAllowed) {
                // cues step 4
                    this.handleFinishedLoadingUpload(setOnce, index);
                } else {
                    // skips ahead to step 7
                    this.removeFileObjects();
                }
            }
            
        }
        if (this.props.projectId !== prevProps.projectId && this.props.projectId !== null) {
            this.props.onUpdateProjectId(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }
    }


    componentWillUnmount () {
        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            this.props.closeScratch(content);
        });
    }


    // step 4 is below, in mapDispatchToProps

    // step 5: called from componentDidUpdate when project state shows
    // that project data has finished "uploading" into the browser
    handleFinishedLoadingUpload (setOnce, index) {
        const loadingState = 'SHOWING_WITHOUT_ID';
        this.props.requestProjectUpload(loadingState);
        if (setOnce) setOnce(index.current);
        if (this.fileToUpload && this.fileReader) {
            // begin to read data from the file. When finished,
            // cues step 6 using the reader's onload callback
            this.fileReader.readAsArrayBuffer(this.fileToUpload);
        } else {
            this.props.cancelFileUpload(this.props.loadingState);
            // skip ahead to step 7
            this.removeFileObjects();
        }
    }
    // used in step 6 below
    getProjectTitleFromFilename (fileInputFilename) {
        if (!fileInputFilename) return '';
        // only parse title with valid scratch project extensions
        // (.sb, .sb2, and .sb3)
        const matches = fileInputFilename.match(/^(.*)\.sb[23]?$/);
        if (!matches) return '';
        return matches[1].substring(0, 100); // truncate project title to max 100 chars
    }
    // step 6: attached as a handler on our FileReader object; called when
    // file upload raw data is available in the reader
    onload () {
        if (this.fileReader) {
            this.props.onLoadingStarted();
            const filename = this.fileToUpload && this.fileToUpload.name;
            let loadingSuccess = false;
            this.props.vm.loadProject(this.fileReader.result)
                .then(() => {
                    if (filename) {
                        const uploadedProjectTitle = this.getProjectTitleFromFilename(filename);
                        this.props.onSetProjectTitle(uploadedProjectTitle);
                    }
                    loadingSuccess = true;
                })
                .catch(error => {
                    log.warn(error);
                    alert(this.props.intl.formatMessage(messages.loadError)); // eslint-disable-line no-alert
                })
                .then(() => {
                    this.props.onLoadingFinished(this.props.loadingState, loadingSuccess);
                    // go back to step 7: whether project loading succeeded
                    // or failed, reset file objects
                    this.removeFileObjects();
                });
        }
    }
    // step 7: remove the <input> element from the DOM and clear reader and
    // fileToUpload reference, so those objects can be garbage collected
    removeFileObjects () {
        if (this.inputElement) {
            this.inputElement.value = null;
            document.body.removeChild(this.inputElement);
        }
        this.inputElement = null;
        this.fileReader = null;
        this.fileToUpload = null;
    }


    render () {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,

    saveProjectSb3: PropTypes.func,
    onSaveFinished: PropTypes.func,
    closeScratch: PropTypes.func,
    scratchFile: PropTypes.instanceOf(Blob),
    once: PropTypes.any,
    setOnce: PropTypes.func,
    index: PropTypes.any,
    isClose: PropTypes.bool,
    baiMau: PropTypes.instanceOf(Blob),

    isShowingWithoutId: PropTypes.bool,

    loadingState: PropTypes.oneOf(LoadingStates),
    projectChanged: PropTypes.bool,
    userOwnsProject: PropTypes.bool,


    canSave: PropTypes.bool,
    cancelFileUpload: PropTypes.func,
    closeFileMenu: PropTypes.func,
    isLoadingUpload: PropTypes.bool,
    onLoadingFinished: PropTypes.func,
    onLoadingStarted: PropTypes.func,
    onSetProjectTitle: PropTypes.func,
    requestProjectUpload: PropTypes.func
};

GUI.defaultProps = {
    isScratchDesktop: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => {},
    onUpdateProjectId: () => {},
    onVmInit: (/* vm */) => {}
};

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const user = state.session && state.session.session && state.session.session.user;

    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm,


        saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
        isShowingWithoutId: getIsShowingWithoutId(loadingState),
        loadingState: loadingState,
        projectChanged: state.scratchGui.projectChanged,
        userOwnsProject: ownProps.authorUsername && user &&
            (ownProps.authorUsername === user.username),

        isLoadingUpload: getIsLoadingUpload(loadingState)
        // changeLang: state.changeLang
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal()),

    cancelFileUpload: loadingState => dispatch(onLoadedProject(loadingState, false, false)),
    closeFileMenu: () => dispatch(closeFileMenu()),
    // transition project state from loading to regular, and close
    // loading screen and file menu
    onLoadingFinished: (loadingState, success) => {
        dispatch(onLoadedProject('LOADING_VM_FILE_UPLOAD', ownProps.canSave, success));
        dispatch(closeLoadingProject());
        dispatch(closeFileMenu());
    },
    // show project loading screen
    onLoadingStarted: () => dispatch(openLoadingProject()),
    onSetProjectTitle: title => dispatch(setProjectTitle(title)),
    // step 4: transition the project state so we're ready to handle the new
    // project data. When this is done, the project state transition will be
    // noticed by componentDidUpdate()
    requestProjectUpload: loadingState => dispatch(requestProjectUpload(loadingState))
});


const mergeProps = (stateProps, dispatchProps, ownProps) => Object.assign(
    {}, stateProps, dispatchProps, ownProps
);

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    SBFileUploaderHOC,
    cloudManagerHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
